import type { CharacterDisplayMode } from "@-/dev.improve.haniverse.routes.nav._context";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { cn } from "@-/com.npmjs.cn";
import { Pressable } from "@-/com.npmjs.react-native";

export function GlyphStyleToggle({
  className,
  displayMode,
  hitSlop = 8,
  iconSize = 24,
  onPress,
}: {
  className?: string;
  displayMode: CharacterDisplayMode;
  hitSlop?: number;
  iconSize?: number;
  onPress: () => void;
}) {
  return (
    <Pressable
      accessibilityLabel="Change glyph style"
      accessibilityRole="button"
      className={cn(className)}
      hitSlop={hitSlop}
      onPress={onPress}
    >
      <Icon name={displayMode === "svg" ? "MdTextFields" : "MdGesture"} size={iconSize} />
    </Pressable>
  );
}
